<template>
    <div class="modal fade" tabindex="-1" role="dialog" id="RastreamentoModal" data-backdrop="static" aria-labelledby="gridSystemModalLabel">
        <div class="modal-dialog modal-lg" role="document" style="width: calc(100vw - 30px); height: calc(100vh - 100px)">
            <div class="modal-content">
                <div class="modal-header">
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                    <h4 class="modal-title" id="gridSystemModalLabel">Rastreador {{id}}</h4>
                </div>
                <div class="modal-body" v-if="id">
                    <index :id="id"/>
                </div>
            </div><!-- /.modal-content -->
        </div><!-- /.modal-dialog -->
    </div><!-- /.modal -->
</template>

<style scoped>
    .modal-header .close {
        margin-top: 2px;
    }
    .modal .close, .modal .modal-title {
        color: white;
    }
    .close {
        opacity: 1;
    }
</style>

<script>

    import Index from '../admin/Index';

    export default {
        ID: "#RastreamentoModal",

        name: 'RastreamentoModal',

        props: {
            id: null
        },

        components: {
            Index
        },

        mounted () {
            $("#RastreamentoModal").on('hide.bs.modal', (event) => {
                this.$emit("closed")
            });
        }
    }

</script>
